import { getScopeValueFields } from '../shape-map/record-types';

export function buildScopeValues(entity, record) {
  const fields = getScopeValueFields(entity);

  return fields.reduce((scopeValues, field) => {
    scopeValues[field] = record?.[field];
    return scopeValues;
  }, {});
}
